/**
 * Glyph roles the image viewer can use for its chrome.
 * The drawings themselves live in the site library; these are only the role ids.
 */

import { GLYPH_ROLES } from '../library/schema.js';

export const ICON_GLYPHS = GLYPH_ROLES.map((role) => ({ id: role.id, label: role.label }));

export const ICON_MODULES = Object.fromEntries(
    GLYPH_ROLES.map((role) => [role.moduleId, role.id]),
);

export function iconGlyph(modules, id, layer) {
    const entry = modules?.[id];
    const key = layer === 'phone' || layer === 'tablet' ? layer : 'desktop';
    const box = entry?.[key] || entry?.desktop || entry?.phone;
    return box?.glyph || ICON_MODULES[id] || 'close';
}

function placedLength(value) {
    return value && value !== 'auto' ? value : undefined;
}

/** Position from a dragged box. An untouched icon keeps its own layout. */
export function iconBoxStyle(box) {
    if (!box || box.anchor !== 'free') return undefined;
    // Width and height stay on the element unless a resize stored a real length.
    // Writing `auto` here collapses the logo mask down to the text line.
    const width = placedLength(box.w);
    const height = placedLength(box.h);
    const xCenter = box.x === 'center';
    const yCenter = box.y === 'center';
    const transform = [
        xCenter ? 'translateX(-50%)' : '',
        yCenter ? 'translateY(-50%)' : '',
    ].filter(Boolean).join(' ');
    return {
        position: 'fixed',
        left: xCenter ? '50%' : box.x,
        top: yCenter ? '50%' : box.y,
        ...(width ? { width } : {}),
        ...(height ? { height } : {}),
        transform: transform || 'none',
        zIndex: 30,
    };
}
